module.exports = __webpack_public_path__ + "fonts/inter-v20-latin-600.2ede57db.woff2";